import { API } from "./api";

export const getAllMobileLocations = () => API.get(`/mobileLocation`);
export const getActiveMobileLocations = () =>
  API.get(`/mobileLocation?isActive=true`);

export const createMobileLocation = (mobileLocation) =>
  API.post(`/mobileLocation`, mobileLocation);

export const deleteMobileLocation = (mobileLocationId) =>
  API.delete(`/mobileLocation/${mobileLocationId}`);

export const updateMobileLocation = (id, mobileLocation) =>
  API.put(`mobileLocation/${id}`, mobileLocation);
